module.exports = __webpack_public_path__ + "img/Italian.ccb57443.svg";